import axios from 'axios'
import i18n from './../plugins/i18n'

export default {
  // создание закона
  createLaw(data) {
    return axios.post(`${i18n.locale}/api/law/create`, data)
  },

  // данные закона
  getLaw(id) {
    return axios.get(`${i18n.locale}/api/law/${id}`)
  },

  // обновление Закона
  updateLaw(data, id) {
    return axios.patch(`${i18n.locale}/api/law/editLaw/${id}`, data)
  },

  // удаляем разработчика у закона
  deleteDeveloper(id) {
    return axios.delete(`${i18n.locale}/api/law/deleteLawDeveloper/${id}`)
  },

  // добавляем разработчика к закону
  addDeveloper(id, data) {
    return axios.post(`${i18n.locale}/api/law/createLawDeveloper/${id}`, data)
  },

  //список законов
  getList(type, params) {
    let param = ''

    for (let field in params) {
      param += `${field}=${params[field]}&`
    }

    return axios.get(`${i18n.locale}/api/public/search/law/${type}/?${param}`).then((response) => {
      return Promise.resolve(response.data)
    })
  },

  // обновление статуса закона
  updateStatus(id, data) {
    return axios.post(`${i18n.locale}/api/law/status/${id}`, data)
  },

  // получение данных для поиска
  getLawData() {
    return axios.get(`${i18n.locale}/api/public/search/lawData`)
  },

  // информация о законе
  getLawDeveloperInfo(id) {
    return axios.get(`${i18n.locale}/api/law/lawDeveloper/info/${id}`)
  },

  // смена поля требуется ли решение
  setSolveNeeded(id, bool) {
    bool = bool === true ? 1 : 0
    return axios.post(`${i18n.locale}/api/law/setSolveNeeded/${id}/${bool}`)
  },

  //статистика по году
  getStatisticList(year) {
    if(!year) {
      year = new Date().getFullYear()
    }
    return axios.get(`${i18n.locale}/api/public/search/lawStatistic/${year}`).then((response) => {
      return Promise.resolve(response.data)
    })
  },

  //статистика
  getStatisticListAll() {
    return axios.get(`${i18n.locale}/api/law/download/statistics/all`).then((response) => {
      return Promise.resolve(response.data)
    })
  },

  // удаление проекта
  deleteLawProject(id) {
    return axios.delete(`${i18n.locale}/api/law/deleteLawProject/${id}`)
  },

  // данные для формы проекта
  getProjectFormData(id) {
    return axios.get(`${i18n.locale}/api/law/lawProject/formData/${id}`)
  },

  // создание проекта
  createLawProject(id, bool, data) {
    bool = bool === true ? 1 : 0
    return axios.post(`${i18n.locale}/api/law/createLawProject/${id}/${bool}`, data)
  },

  // смена стадии
  changeStage(projectId, stageId) {
    return axios.get(`${i18n.locale}/api/law/changeLawProjectStage/${projectId}/${stageId}`)
  },

  // добавление НПА к проекту закона
  addNpaToLawProject(projectId, npaId) {
    return axios.get(`${i18n.locale}/api/law/setNpaToLawProject/${projectId}/${npaId}`)
  },

  // печать в ворд исполнения законов
  printLawTable (param) {
    return axios.get(`${i18n.locale}/api/public/search/law/public/print?${param}`, {responseType: 'arraybuffer'})
  },

  getNormData () {
    return axios.get(`${i18n.locale}/api/public/search/normData/?page=1&orderBy=id&orderDir=desc&viewType=2`)
  },

  createLawNorm (form) {
    return axios.post(`${i18n.locale}/api/law/create/norm`, form)
  },

  createLawArticle (form) {
    return axios.post(`${i18n.locale}/api/law/create/article`, form)
  },

  editLawArticle (form) {
    return axios.patch(`${i18n.locale}/api/law/editArticle/${form.id}`, form)
  },

  createByLaw (form) {
    return axios.post(`${i18n.locale}/api/law/create/byLaw`, form)
  },

  removeArticle(form) {
    return axios.delete(`${i18n.locale}/api/law/deleteArticle/${form.id}`)
  },

  removeByLaw(id) {
    return axios.delete(`${i18n.locale}/api/law/deleteByLaw/${id}`)
  },

  removeNorm(id) {
    return axios.delete(`${i18n.locale}/api/law/deleteNorm/${id}`)
  },

  editNorm(form) {
    return axios.patch(`${i18n.locale}/api/law/editNorm/${form.id}`, form)
  },

  getNorm(id) {
    return axios.get(`${i18n.locale}/api/law/get/norm/${id}`)
  },

  createLawNormAct (form) {
    return axios.post(`${i18n.locale}/api/law/create/byLaw`, form)
  },

  editByLaw (form) {
    return axios.patch(`${i18n.locale}/api/law/editByLaw/${form.id}`, form)
  },

  getStatisticDataByType (type, params) {
    let param = ''
    let url = ''

    for (let field in params) {
      param += `${field}=${params[field]}&`
    }

    if (Object.keys(params).length > 0) {
      url = `${i18n.locale}/api/law/get/statistics/${type}?${param}`
    } else {
      url = `${i18n.locale}/api/law/get/statistics/${type}`
    }

    return axios.get(url)
  },

  getDocumentByCode (code) {
    return axios.get(`${i18n.locale}/api/law/openData/getDocument/${code}`)
  },

  getExelFile() {
    return axios.get(`${i18n.locale}/api/law/upload/excel`)
  },

  addLawDocument(lawId, data) {
    return axios.post(`${i18n.locale}/api/law/addLawDocument/${lawId}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  removeLawDocument(lawId, docId) {
    return axios.delete(`${i18n.locale}/api/law/deleteLawDocument/${lawId}/${docId}`)
  },

  addNormStage (lawId, normId, form) {
    return axios.post(`${i18n.locale}/api/law/addNormStage/${lawId}/${normId}`, form)
  },

  deleteNormStage (lawId, normId, stage) {
    return axios.post(`${i18n.locale}/api/law/deleteNormStage/${lawId}/${normId}/`, stage)
  },

  getProfile (page) {
    return axios.get(`${i18n.locale}/api/public/search/law/profile?page=${page}`)
  },

  getNotificationById (id) {
    return axios.get(`${i18n.locale}/api/law/notification/${id}`)
  },

  searchLawToChange(search) {
    return axios.get(`${i18n.locale}/api/public/search/law-to-change/?search=${search}`).then((response) => {
      return Promise.resolve(response.data)
    })
  },

}
